<app-card icon="flight" title="Airline Statistics" subtitle="Airline performance breakdown" iconGradient="from-cyan-500 to-blue-600" class="h-full">
    <ng-template #headerTemplate>
        <div class="ml-auto">
            <app-excel-button [data]="exportData()" [excelTitle]="'airline-statistics'" [columns]="cols"></app-excel-button>
        </div>
    </ng-template>
    <app-table-component
        [cols]="cols"
        [data]="airlineStatisticsData() || []"
        [loading]="loading()"
    ></app-table-component>
</app-card>

<ng-template #airlineCodeTemplate let-rowData="rowData">
    <span class="airline-code">{{ rowData.airlineCode }}</span>
</ng-template>

<ng-template #paxProgressTemplate let-rowData="rowData">
    <div class="pax-progress">
        <span>{{ rowData.pax }}</span>
    </div>
</ng-template>
